function moveElement({ target, destination, position = 'append' }) {
  const el = typeof target === 'string' ? document.querySelector(target) : target;
  const dest = typeof destination === 'string' ? document.querySelector(destination) : destination;

  if (!el || !dest) return console.warn('Invalid target or destination');

  try {
    switch (position) {
      case 'append': dest.append(el); break;
      case 'prepend': dest.prepend(el); break;
      case 'before': dest.before(el); break;
      case 'after': dest.after(el); break;
      case 'replace': dest.replaceWith(el); break;
      default: console.warn('Unsupported position:', position);
    }
  } catch (e) {
    console.error('Move failed:', e);
  }
}

function showMore() {
  const btns = document.querySelectorAll('.allter-btn--readmore');
  if (!btns.length) return;

  btns.forEach(btn => {
    btn.addEventListener('click', function () {
      const text = this.nextElementSibling 
        ? this.nextElementSibling 
        : this.previousElementSibling;

      text.classList.toggle('fullContent');

      if (text.classList.contains('fullContent')) {
        this.textContent = 'Read Less';
      } else {
        this.textContent = 'Read More';
      }
    });
  });
}

function removeEmptyElements() {
  let description = document.getElementById('description-1');

  if(!description) return;

  let elements = description.querySelectorAll('*');

  elements.forEach(el => {
    const text = el.textContent.replace(/\s+/g, '').trim();

    const meaningfulChildren = [...el.children].filter(child =>
      child.textContent.replace(/\s+/g, '').trim() !== ''
    );

    if (text === '' && meaningfulChildren.length === 0) {
      el.remove();
    }
  });
}

function clampDescriptionDirect(selector) {
  const el = document.querySelector(selector);

  if (!el) return;

  if (el.querySelector('.read-more-btn')) {
    return;
  }

  el.classList.add('clamp-3');

  const clampedHeight = el.getBoundingClientRect().height;

  el.classList.remove('clamp-3');
  const fullHeight = el.getBoundingClientRect().height;

  if (fullHeight <= clampedHeight + 5) {
    el.classList.add('clamp-3'); 
    return;
  }

  el.classList.add('clamp-3');

  const btn = document.createElement('button');
  btn.className = 'read--more-btn';
  btn.textContent = 'Read more...';

  btn.addEventListener('click', () => {
    el.classList.toggle('expanded');
    btn.textContent = el.classList.contains('expanded') ? 'Read less' : 'Read more...';
  });

  el.insertAdjacentElement('afterend', btn);
}

subscribe(PUB_SUB_EVENTS.variantChange, (payload) => {
  const { variant } = payload.data;

  if (!variant) return;

  const price = variant.price / 100;
  const compareAtPrice = variant.compare_at_price / 100;

  const discountBadges = document.querySelectorAll('.discount-badge');

  if (!discountBadges.length) return;

  if (compareAtPrice > price) {
    const discountPercent = Math.round(
      ((compareAtPrice - price) / compareAtPrice) * 100
    );

    discountBadges.forEach(discountBadge => {
      discountBadge.textContent = `${discountPercent}% OFF`;
      discountBadge.style.display = 'inline-block';
    })
  } else {
    discountBadges.forEach(discountBadge => {
      discountBadge.style.display = 'none'
    });
  }
});

document.addEventListener('DOMContentLoaded', function(){
  moveElement({
    target: '#shopify-section-template--24280044405052__scrolling_text_6dCNQe',
    destination: '#productSizeSelector',
    position: 'after'
  });
  showMore();
  removeEmptyElements();
  clampDescriptionDirect('#description-1');
});
